import styles from './catalog-picker-modal.module.css'

import React from 'react'

import { Button, Flex, Text } from 'components/ds'

type SelectionBarProps = {
  count: number
  onClear: () => void
}

export const SelectionBar = ({ count, onClear }: SelectionBarProps) => (
  <Flex align="center" justify="between" className={styles.selectionBar}>
    <Flex align="center" gap="2">
      <Text size="2" weight="medium">
        {count} selected
      </Text>
      <Text size="2" color="gray" aria-hidden="true">
        ·
      </Text>
      <Button variant="ghost" color="gray" size="1" onClick={onClear}>
        Clear
      </Button>
    </Flex>
  </Flex>
)
